import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/main.scss';
import * as serviceWorker from './serviceWorker';
import { ChakraProvider } from '@chakra-ui/react';

import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { customTheme } from './theme';
import { DynamicRendering } from './components/shared/general';
//import { getBasename } from 'src/utils';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
//const root2 = ReactDOM.createRoot(document.getElementById('root-2') as HTMLElement);

const router = createBrowserRouter(
  [
    {
      path: '*',
      element: <DynamicRendering rootId={'root'} />
    },
    /*{
      path: '/rentestanden/:mortgageType/:mortgageTerm/',
      element: <DynamicRendering component={'interest-providers-list'} rootId={'root'} />
    },
    {
      path: '/en/mortgage-interest-rates/:mortgageType/:mortgageTerm/',
      element: <DynamicRendering component={'interest-providers-list'} rootId={'root'} />
    },
    {
      path: '/en/mortgage-interest-rates/',
      element: <DynamicRendering component={'interest-providers-list'} rootId={'root'} />
    },
    {
      path: '/rentestanden/',
      element: <DynamicRendering component={'interest-providers-list'} rootId={'root'} />
    },*/
    // debug``
    {
      path: '/react-tool-bike-relay-40-years.html',
      element: <DynamicRendering component={'bike-relay-40-years'} rootId={'root'} />
    },
    {
      path: '/react-tool-interest-rates-historical-slider.html',
      element: <DynamicRendering component={'interest-rates-historical-slider'} rootId={'root'} />
    },
    {
      path: '/react-tool-form-sustainability-scan.html',
      element: <DynamicRendering component={'sustainability-scan-form'} rootId={'root'} />
    },
    {
      path: '/react-tool-form-privacy.html',
      element: <DynamicRendering component={'form-privacy'} rootId={'root'} />
    },
    {
      path: '/react-tool-form-employer-statement.html',
      element: <DynamicRendering component={'employer-statement-form'} rootId={'root'} />
    },
    {
      path: '/react-tool-form-additional-facilities.html',
      element: <DynamicRendering component={'additional-facilities-form'} rootId={'root'} />
    },
    {
      path: '/react-tool-form-mortgage-certificate.html',
      element: <DynamicRendering component={'mortgage-certificate-form'} rootId={'root'} />
    },
    {
      path: '/react-tool-decision-tree-remodel.html',
      element: <DynamicRendering component={'decision-tree'} id={'remodel'} rootId={'root'} />
    },
    {
      path: '/react-tool-decision-tree-divorce.html',
      element: <DynamicRendering component={'decision-tree'} id={'divorce'} rootId={'root'} />
    },
    {
      path: '/react-tool-questionnaire.html',
      element: <DynamicRendering component={'questionnaire'} rootId={'root'} />
    },
    {
      path: '/react-tool-interest-providers-list.html',
      element: <DynamicRendering component={'interest-providers-list'} rootId={'root'} />
    },
    {
      path: '/react-tool-calculator-student-loan.html',
      element: <DynamicRendering component={'calculator-student-loan'} rootId={'root'} />
    },
    {
      path: '/react-tool-calculator-additional-payment.html',
      element: <DynamicRendering component={'calculator-additional-payment'} rootId={'root'} />
    },
    {
      path: '/react-tool-calculator-square-meter-average-price.html',
      element: (
        <DynamicRendering component={'calculator-square-meter-average-price'} rootId={'root'} />
      )
    },
    {
      path: '/react-tool-calculator-buyer-costs.html',
      element: <DynamicRendering component={'calculator-buyer-costs'} rootId={'root'} />
    },
    {
      path: '/react-tool-calculator-home-value.html',
      element: <DynamicRendering component={'calculator-home-value'} rootId={'root'} />
    }
  ],
  {
    //basename: getBasename()
  }
);

root.render(
  <React.StrictMode>
    <ChakraProvider theme={customTheme} resetCSS={false}>
      <RouterProvider router={router} />
    </ChakraProvider>
  </React.StrictMode>
);

// if there should be more than 2 components on a page
// add a extra div with id root-2
/*
root2.render(
  <React.StrictMode>
    <FormProvider>
      <ChakraProvider theme={customTheme}>
        <DynamicRendering component={'additional-facilities'} rootId={'root-2'} />
      </ChakraProvider>
    </FormProvider>
  </React.StrictMode>
);
*/

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
